import React from 'react';
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

import { Items } from 'services/action';
import { Skeletons } from 'ui/components/skeleton';

const initialState = {
  showDelete: false,
  showDeactive: false,
};

export const Action = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state.Form);

  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Items.Show']
  );

  const [{ showDelete, showDeactive }, setState] = React.useState(initialState);

  const dummy = Array.from({ length: 3 }, (v, i) => i);

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showDelete: false,
      showDeactive: false,
    }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Items.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      History.replace('/inventory');
    }
  };

  const $handleStatus = async () => {
    if (data?.is_active) {
      const req = await Dispatch(Items.$deactivated(data?.id));
      if (req?.message === 'success') {
        onSubmit();
        $handleClose();
      }
    } else {
      const req = await Dispatch(Items.$activated(data?.id));
      if (req?.message === 'success') {
        onSubmit();
        $handleClose();
      }
    }
  };

  return (
    <div className="d-flex align-items-center gap-1 px-3 me-2 px-md-0 py-2">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          <button
            onClick={() =>
              setState((prevState) => ({ ...prevState, showDeactive: true }))
            }
            className={cn(
              'btn px-2 py-1',
              data?.is_active ? 'btn-danger' : 'btn-secondary'
            )}
          >
            <Fi.FiPower size="17" />
            <span className="ms-2">
              {data?.is_active ? 'Nonaktifkan' : 'Aktifkan'}
            </span>
          </button>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Perbaharui</Tooltip>}
          >
            <Link
              to={`/inventory/${data?.id}/update`}
              className={cn('btn btn-primary px-2')}
            >
              <Fi.FiEdit size="17" />
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Hapus</Tooltip>}
          >
            <button
              className={cn('btn btn-danger px-2')}
              onClick={() =>
                setState((prevState) => ({ ...prevState, showDelete: true }))
              }
            >
              <Fi.FiTrash2 size="17" />
            </button>
          </OverlayTrigger>
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal showVoid */}
      <Modal
        show={showDeactive}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleStatus}
                disabled={StateForm?.loading}
              >
                Konfirmasi
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
